import * as api from '@/api/group';
import * as api2 from '@/api/homepage';
import bookmarkedSvg from '@/static/imgs/bookmarked.svg';
import bookmarkSvg from '@/static/imgs/post-detail-bookmark.svg';
import likePainSvg from '@/static/imgs/post-detail-like-pain.svg';
import likeSvg from '@/static/imgs/post-detail-like.svg';
import sharePlainSvg from '@/static/imgs/share-plain.svg';
import { useSharedData } from '@ns/mpa';
import { Button, Input, message, Popover } from 'antd';
import ClipboardJS from 'clipboard';
import { useEffect, useState } from 'react';
import './index.scss';
type GroupPostDetailToolsProps = {
  uid: string;
  like_count: number;
  user_like_status: boolean;
  user_bookmark_status: boolean;
};
const clipboard = new ClipboardJS('#copyBtn');

clipboard.on('success', () => {
  message.success('复制成功');
});

const GroupPostDetailTools: React.FC<{ isMobile?: boolean }> = ({
  isMobile,
}) => {
  const post = useSharedData<GroupPostDetailToolsProps>('post');
  const [bookmarkStatus, setBookmarkStatus] = useState(
    post.user_bookmark_status,
  );
  const [likeStatus, setLikeStatus] = useState(post.user_like_status);
  const [likeCount, setLikeCount] = useState(post.like_count);

  useEffect(() => {
    return () => {
      clipboard.destroy();
    };
  }, []);
  return (
    <div className="group-post-detail-tools flex space-between items-center">
      <div
        className={`flex items-center ${
          !isMobile
            ? 'border-1px border-solid border-hex-E5E6EB rounded-6px p-8px'
            : ''
        }  cursor-pointer ${likeStatus ? 'active' : ''}`}
        onClick={async () => {
          if (likeStatus) {
            await api.unlikeGroupPost(post.uid);
            setLikeCount(likeCount - 1);
          } else {
            await api.likeGroupPost(post.uid);
            setLikeCount(likeCount + 1);
            try {
              const usertaskRes = await api2.getUnreadUserTask();
              if (usertaskRes.jifen && usertaskRes.building_score)
                message.success(
                  `积分+${usertaskRes.jifen},共建值+${usertaskRes.building_score}`,
                );
              if (usertaskRes.jifen && !usertaskRes.building_score)
                message.success(`积分+${usertaskRes.jifen}`);
              if (!usertaskRes.jifen && usertaskRes.building_score)
                message.success(`共建值+${usertaskRes.building_score}`);
            } catch (e) {}
          }
          setLikeStatus(!likeStatus);
        }}
      >
        <img
          className="mr-4px w-24px h-24px"
          src={likeStatus ? likeSvg : likePainSvg}
        />
        <div>{likeCount}</div>
      </div>
      <div
        className={`flex items-center ${
          !isMobile
            ? 'border-1px border-solid border-hex-E5E6EB rounded-6px p-8px'
            : ''
        } cursor-pointer ml-10px ${bookmarkStatus ? 'active' : ''}`}
        onClick={async () => {
          if (bookmarkStatus) {
            await api.unbookmarkGroupPost(post.uid);
          } else {
            await api.bookmarkGroupPost(post.uid);
          }
          setBookmarkStatus(!bookmarkStatus);
        }}
      >
        <img
          className="mr-4px w-24px h-24px"
          src={bookmarkStatus ? bookmarkedSvg : bookmarkSvg}
        />
        <div>收藏</div>
      </div>
      {!isMobile && (
        <Popover
          content={
            <div data-flex>
              <Input defaultValue={window.location.href} />
              <Button id="copyBtn" data-clipboard-text={window.location.href}>
                复制
              </Button>
            </div>
          }
          title="分享的链接"
          trigger={'click'}
        >
          <div className="flex items-center border-1px border-solid border-hex-E5E6EB rounded-6px p-8px cursor-pointer ml-10px">
            <img className="mr-4px w-24px h-24px" src={sharePlainSvg} />
            <span>分享</span>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default GroupPostDetailTools;
